import React from 'react';
import WalletPreview from './WalletPreview';
import { LINKS } from '../brand';
import './Wallet.css';

const Wallet = () => (
  <section id="wallet" className="wallet" aria-labelledby="wallet-title">
    <div className="container">
      <h2 id="wallet-title" className="section-title">Dans Apple Wallet</h2>
      <p className="section-subtitle">
        Trois couleurs, une même carte : Boursier, Standard, ou autre.
        Le bol et le nom de la société forment la marque du pass.
      </p>
      <WalletPreview layout="row" />
      <p className="wallet-cta-row">
        <a
          className="btn btn-primary"
          href={LINKS.manageCard}
          target="_blank"
          rel="noopener noreferrer"
        >
          Gérer ma carte
        </a>
        <a
          className="btn btn-secondary"
          href={LINKS.ios}
          target="_blank"
          rel="noopener noreferrer"
        >
          Ouvrir Shini Pay
        </a>
      </p>
    </div>
  </section>
);

export default Wallet;
